import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import CleanIcon from '../assets/x-circle-fill.svg';
import { useDebounce } from "use-debounce";
import { useAppDispatch, useAppSelector } from "../hooks/hook";
import { setClearGlobalSearchUser } from "../store/slices/appSlice";
import { useTypedTranslation } from "../hooks/useTypedTranslation";
const InputComponent = ({ inputProps, classes, returnValue, isCleanIcon, refInput, refContainer }) => {
    const [name, setName] = useState('');
    const isClearGlobalSearchUser = useAppSelector(state => state.app.clearGlobalSearchUser);
    const dispatch = useAppDispatch();
    const { t } = useTypedTranslation();
    const [debouncedText] = useDebounce(name, 1000);
    const handleChange = (e) => {
        setName(e.target.value);
    };
    useEffect(() => {
        if (returnValue) {
            returnValue(debouncedText);
        }
    }, [debouncedText]);
    useEffect(() => {
        if (isClearGlobalSearchUser) {
            setName('');
            //returnValue(name)
            dispatch(setClearGlobalSearchUser(false));
        }
    }, [isClearGlobalSearchUser]);
    return (_jsxs("div", { className: classes, style: { position: 'relative' }, ref: refContainer, children: [_jsx("input", Object.assign({ type: "text", value: name, onChange: handleChange }, inputProps, { placeholder: t('search'), ref: refInput })), isCleanIcon && Boolean(name.length) &&
                _jsx("div", { style: { position: 'absolute', right: '14px', top: '12px' }, children: _jsx(CleanIcon, { cursor: 'pointer', onClick: () => setName('') }) })] }));
};
export default InputComponent;
